module.exports = __webpack_public_path__ + "static/media/uruguai.f9ee8213.jpg";